import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  @Input() label: string = '';
  @Input() options: { value: string; label: string }[] = [];
  @Input() selectedValue: string = '';
  @Output() selectionChanged = new EventEmitter<string>();

  onSelectionChange() {
    this.selectionChanged.emit(this.selectedValue);
  }
}
